import React from 'react';

// Components
import ContactPastille from './ContactPastille';

// Types
import AdvisorInfos from '@/types/advisor-infos';
import ComparisonContact from '@/types/comparison-contact';
import GenericContact from '@/types/generic-contact';

// Utils
import { getContactName } from '@/utils/contacts';

type Props = {
  contact?: GenericContact | AdvisorInfos | ComparisonContact;
  showNameLabel?: boolean;
  showTooltip?: boolean;
};

/**
 * A React functional component that displays the name of a contact along with a pastille with their initials.
 *
 * @component
 * @param {Props} props - The properties object.
 * @param {Contact} props.contact - The contact object containing information about the contact.
 * @param {showNameLabel} props.showNameLabel - A boolean that determines whether the contact's name should be shown. Default to true.
 * @returns {JSX.Element} A JSX element that renders the contact's name and a pastille.
 */
const ContactLabel: React.FC<Props> = ({ contact, showNameLabel = true, showTooltip = false }) => {
  const name = getContactName(contact ?? {});
  return (
    <>
      {contact && (
        <div className="contact-label">
          <ContactPastille contact={contact} tooltip={showTooltip} />
          {showNameLabel && (
            <span data-private data-dd-privacy="mask">
              {name}
            </span>
          )}
        </div>
      )}
    </>
  );
};

export default ContactLabel;
